import React, { useState } from 'react';
import Hero from '../components/common/Hero';
import Button from '../components/common/Button';
import { caseStudiesHero } from '../assets/images/imageImports';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    
    // Create mailto link with form data
    const subject = encodeURIComponent(`Contact from ${name}`);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
    const mailtoLink = `mailto:greg@skysightanalytics.com?subject=${subject}&body=${body}`;
    
    // Open email client
    window.location.href = mailtoLink;
  };

  return (
    <div className="contact-page">
      <Hero
        title="Get in Touch"
        subtitle="Ready to transform your finance and data infrastructure? Let's discuss how SkySight Analytics can help your business scale or prepare for exit."
        buttonText="Call Now"
        buttonLink="tel:+16472047295"
        backgroundImage={caseStudiesHero}
      />
      
      <section className="section">
        <div className="container">
          <div className="row">
            <div className="col-6">
              <div className="card">
                <h3>Send us a Message</h3>
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      className="form-textarea"
                      placeholder="Tell us about your business needs and how we can help..."
                    ></textarea>
                  </div>
                  
                  <Button type="primary" size="large" style={{width: '100%'}}>
                    Send Message
                  </Button>
                </form>
              </div>
            </div>
            
            <div className="col-6">
              <div className="card">
                <h3>Contact Information</h3>
                <div className="contact-info">
                  <div className="contact-item">
                    <h4>Email</h4>
                    <p><a href="mailto:greg@skysightanalytics.com">greg@skysightanalytics.com</a></p>
                  </div>
                  
                  <div className="contact-item">
                    <h4>Phone</h4>
                    <p><a href="tel:+16472047295">+1 (647) 204-7295</a></p>
                  </div>
                  
                  <div className="contact-item">
                    <h4>Location</h4>
                    <p>Toronto, Ontario<br />Canada</p>
                  </div>
                  
                  <div className="contact-item">
                    <h4>Business Hours</h4>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                  </div>
                </div>
                
                <div className="text-center" style={{marginTop: '2rem'}}>
                  <Button 
                    to="tel:+16472047295" 
                    type="secondary" 
                    size="large"
                    style={{marginRight: '1rem'}}
                  >
                    Call Now
                  </Button>
                  <Button 
                    to="mailto:greg@skysightanalytics.com" 
                    type="primary" 
                    size="large"
                  >
                    Email Us
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 